/* eslint-disable react/prop-types */
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from 'react';
import Add from '@react/react-spectrum/Icon/Add';
import Education from '@react/react-spectrum/Icon/Education';
import PlayCircle from '@react/react-spectrum/Icon/PlayCircle';
import Plug from '@react/react-spectrum/Icon/Plug';
import MagicWand from '@react/react-spectrum/Icon/MagicWand';
import MoreCircle from '@react/react-spectrum/Icon/MoreCircle';
import OpenRecent from '@react/react-spectrum/Icon/OpenRecent';
import Artboard from '@react/react-spectrum/Icon/Artboard';
import PrintPreview from '@react/react-spectrum/Icon/PrintPreview';
import Project from '@react/react-spectrum/Icon/Project';
import FileTemplate from '@react/react-spectrum/Icon/FileTemplate';
import EmailOutline from '@react/react-spectrum/Icon/EmailOutline';
import Brush from '@react/react-spectrum/Icon/Brush';
import PageBreak from '@react/react-spectrum/Icon/PageBreak';
import FileAdd from '@react/react-spectrum/Icon/FileAdd';
import UploadToCloud from '@react/react-spectrum/Icon/UploadToCloud';
import Home from '@react/react-spectrum/Icon/Home';
import FolderOutline from '@react/react-spectrum/Icon/FolderOutline';
import GlobeGrid from '@react/react-spectrum/Icon/GlobeGrid';

import SpecIcon from '@react/react-spectrum/Icon';
import LearnSVG from '../../../assets/common/Smock_Learn_18_N.svg';

const Icon = ({name}) => {
	switch (name) {
		case 'Education':
			return <Education />;
		case 'Play Circle':
			return <PlayCircle />;
		case 'Plug':
			return <Plug />;
		case 'Magic Wand':
			return <MagicWand />;
		case 'More Circle':
			return <MoreCircle />;
		case 'Open Recent':
			return <OpenRecent />;
		case 'Artboard':
			return <Artboard />;
		case 'Print Preview':
			return <PrintPreview />;
		case 'Project':
			return <Project />;
		case 'File Template':
			return <FileTemplate />;
		case 'Email Outline':
			return <EmailOutline />;
		case 'Brush':
			return <Brush />;
		case 'Page Break':
			return <PageBreak />;
		case 'File Add':
			return <FileAdd />;
		case 'Upload To Cloud':
			return <UploadToCloud />;
		case 'Home':
			return <Home />;
		case 'Folder Outline':
			return <FolderOutline />;
		case 'Globe Grid':
			return <GlobeGrid />;
		case 'Learn':
			return (
				<SpecIcon>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						height='18'
						id='S_Learn_18_N'
						viewBox='0 0 18 18'
						width='18'
					>
						<rect id='Canvas' fill='#ff13dc' opacity='0' width='18' height='18' />
						<path d='M9.25,3.96A4.055,4.055,0,0,0,5.064,7.881c0,.09,0,.179,0,.269a4.493,4.493,0,0,0,1.285,2.987,2.967,2.967,0,0,1,.85,1.692c0,.19,0,.381,0,.571v2.02a1,1,0,0,0,.318.731l.765.714A.5.5,0,0,0,8.627,17H9.869a.5.5,0,0,0,.341-.135l.768-.715a.994.994,0,0,0,.317-.731v-2.3a2.392,2.392,0,0,1,.265-1.156c.35-.637.9-1.143,1.282-1.763a3.885,3.885,0,0,0,.594-2.048A4.057,4.057,0,0,0,9.519,3.96C9.43,3.957,9.34,3.957,9.25,3.96Zm1.969,6.428a5.723,5.723,0,0,0-.974,1.494,3.219,3.219,0,0,0-.175,1.109H8.434a3.535,3.535,0,0,0-.057-.7,3.007,3.007,0,0,0-.344-.876,8.29,8.29,0,0,0-.753-1.033A3.371,3.371,0,0,1,6.26,8.151,2.837,2.837,0,0,1,8.93,5.157a2.628,2.628,0,0,1,.32,0A2.839,2.839,0,0,1,12.24,8.15,3.377,3.377,0,0,1,11.219,10.388Z' />
						<rect height='2.864' rx='0.409' width='1.227' x='8.637' />
						<rect height='1.227' rx='0.409' width='2.864' x='14.568' y='7.773' />
						<rect height='1.227' rx='0.409' width='2.864' x='1.068' y='7.773' />
						<rect
							height='2.863'
							rx='0.409'
							transform='translate(-1.573 3.758) rotate(-45)'
							width='1.227'
							x='3.136'
							y='2.345'
						/>
						<rect
							height='1.227'
							rx='0.409'
							transform='translate(1.649 11.536) rotate(-45)'
							width='2.863'
							x='13.318'
							y='3.163'
						/>
					</svg>
				</SpecIcon>
			);

		case 'Add':
		default:
			return <Add />;
	}
};

export default Icon;
